import type { FixedLineItem, FixedLineItemInput } from '@weft/types';
import { getProductTitle } from 'apps/app/src/services/product/product-title';

export function buildDefaultEditFixedLineItemFormValues({ price, type, modifiedName, lineItemProduct }: FixedLineItem): FixedLineItemInput {
  return {
    price,
    modifiedName: modifiedName ?? getProductTitle(lineItemProduct),
    type,
  };
}